module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-57-min.5c10c855.jpg";